import React, { useState, useEffect } from 'react';
import { t } from '../i18n';

const ICONS = { connection: '🤝', comment: '💬', vote: '👍', tip: '💰', message: '✉️', boost: '🚀' };

function Notifications({ user }) {
  const [notifs, setNotifs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) fetchNotifs();
  }, [user]);

  const fetchNotifs = async () => {
    try {
      const res = await fetch('/api/notifications/', {
        headers: { 'Authorization': `Token ${user.token}` }
      });
      const data = await res.json();
      setNotifs(data.notifications || []);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const markRead = async () => {
    await fetch('/api/notifications/read/', {
      method: 'POST', headers: { 'Authorization': `Token ${user.token}` }
    });
    setNotifs(prev => prev.map(n => ({ ...n, read: true })));
  };

  const clearAll = async () => {
    if (!window.confirm(t('nt_clear_confirm'))) return;
    await fetch('/api/notifications/clear/', {
      method: 'DELETE', headers: { 'Authorization': `Token ${user.token}` }
    });
    setNotifs([]);
    window.history.back();
  };

  if (!user) return <div style={styles.container}><h2 style={{ textAlign: 'center' }}>🔑 Login Required</h2></div>;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>🔔 Notifications</h1>
        <div style={{ display: 'flex', gap: '8px' }}>
          {notifs.some(n => !n.read) && (
            <button style={styles.markBtn} onClick={markRead}>✅ Read All</button>
          )}
          {notifs.length > 0 && (
            <button style={{ ...styles.markBtn, backgroundColor: '#ff4444' }} onClick={clearAll}>🗑️ Clear All</button>
          )}
        </div>
      </div>

      {loading ? <div style={styles.loading}>{t('loading')}</div> :
        notifs.length === 0 ? (
          <div style={styles.empty}>
            <p style={{ fontSize: '48px' }}>🔔</p>
            <p>{t('nt_empty')}</p>
          </div>
        ) : (
          <div style={styles.list}>
            {notifs.map(n => (
              <a key={n.id} href={n.link || '#'} style={{ ...styles.item, backgroundColor: n.read ? 'white' : '#f3e5f5' }}>
                <div style={{ ...styles.icon, backgroundColor: n.read ? '#f0f0f0' : '#6200ea22' }}>
                  {ICONS[n.type] || '🔔'}
                </div>
                <div style={styles.content}>
                  <div style={styles.msg}>{n.message}</div>
                  <div style={styles.time}>{n.created_at}</div>
                </div>
                {!n.read && <div style={styles.dot} />}
              </a>
            ))}
          </div>
        )
      }
    </div>
  );
}

const styles = {
  container: { maxWidth: '700px', margin: '20px auto', padding: '20px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  title: { color: '#6200ea', margin: 0 },
  markBtn: { backgroundColor: '#6200ea', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' },
  loading: { textAlign: 'center', padding: '40px', color: '#999' },
  empty: { textAlign: 'center', padding: '60px', color: '#999' },
  list: { display: 'flex', flexDirection: 'column', gap: '8px' },
  item: { display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px', borderRadius: '12px', textDecoration: 'none', boxShadow: '0 2px 6px rgba(0,0,0,0.08)' },
  icon: { width: '42px', height: '42px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 },
  content: { flex: 1 },
  msg: { fontSize: '14px', color: '#333', fontWeight: '500' },
  time: { fontSize: '11px', color: '#999', marginTop: '3px' },
  dot: { width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#6200ea', flexShrink: 0 },
};

export default Notifications;
